<main class="tr" aria-labelledby="tempo-real-titulo">
  <header class="tr-bar">
    <div class="tr-bar-title">
      <h1 id="tempo-real-titulo"><i class="fas fa-broadcast-tower"></i>Tempo Real</h1>
      <span>O que seus clientes estão fazendo agora · últimos {{ janelaMinutos }} min</span>
    </div>

    <div class="tr-bar-actions">
      <span class="tr-live" [class.alerta]="atualizacaoFalhou">
        <i></i>{{ atualizacaoFalhou ? 'RECONECTANDO' : 'AO VIVO' }}
      </span>
      <span class="tr-atualizado" *ngIf="status === 'pronto'">Atualizado {{ obtenhaTextoAtualizacao() }}</span>
      <button type="button" class="tr-ghost" (click)="carregue()" [disabled]="carregando" aria-label="Atualizar dados agora">
        <i class="fas fa-sync-alt" [class.fa-spin]="carregando"></i>
        <span>Atualizar</span>
      </button>
    </div>
  </header>

  <section class="tr-estado tr-estado-carregando" *ngIf="status === 'carregando'" aria-live="polite">
    <div class="tr-skeleton tr-skeleton-destaque"></div>
    <div class="tr-skeleton-grid">
      <div class="tr-skeleton"></div>
      <div class="tr-skeleton"></div>
      <div class="tr-skeleton"></div>
    </div>
    <span>Buscando o movimento do cardápio…</span>
  </section>

  <section class="tr-estado" *ngIf="status === 'sem_projeto'">
    <div class="tr-estado-icone"><i class="fas fa-chart-line"></i></div>
    <h2>O acompanhamento ainda não está disponível</h2>
    <p>Assim que a análise do cardápio estiver conectada, o movimento aparecerá aqui automaticamente.</p>
  </section>

  <section class="tr-estado tr-estado-erro" *ngIf="status === 'erro'">
    <div class="tr-estado-icone"><i class="fas fa-wifi"></i></div>
    <h2>Não foi possível carregar o tempo real</h2>
    <p>{{ erroMensagem }}</p>
    <button type="button" class="tr-ghost" (click)="carregue()"><i class="fas fa-redo"></i>Tentar novamente</button>
  </section>

  <ng-container *ngIf="status === 'pronto'">
    <aside class="tr-aviso" *ngIf="atualizacaoFalhou" role="status">
      <i class="fas fa-exclamation-circle"></i>
      <span>Mostrando a última leitura disponível. A próxima atualização será tentada automaticamente.</span>
    </aside>

    <section class="tr-resumo" aria-label="Resumo dos últimos 30 minutos">
      <div class="tr-agora">
        <span class="tr-agora-num" [class.zerado]="!dados.visitantesAgora">{{ dados.visitantesAgora | number }}</span>
        <div>
          <strong>{{ dados.visitantesAgora === 1 ? 'acesso ativo no' : 'acessos ativos no' }}<br>cardápio agora</strong>
          <small><i></i> {{ obtenhaResumoIdentificacao() }}</small>
          <button type="button"
                  class="tr-ver-usuarios"
                  *ngIf="dados.visitantesAgora"
                  aria-haspopup="dialog"
                  aria-controls="tr-painel-usuarios"
                  [attr.aria-expanded]="listaUsuariosAberta"
                  (click)="abraListaUsuarios()">
            <i class="fas fa-users"></i>
            Ver quem está online
          </button>
        </div>
      </div>

      <div class="tr-metricas">
        <article class="tr-metrica">
          <span class="tr-metrica-icone"><i class="fas fa-shopping-bag"></i></span>
          <div><strong>{{ formateNumero(dados.resumo?.itensSacolas) }}</strong><span>{{ dados.resumo?.itensSacolas === 1 ? 'item na sacola ativa' : 'itens nas sacolas ativas' }}</span></div>
        </article>
        <article class="tr-metrica tr-metrica-valor">
          <div><strong>{{ formateMoeda(dados.resumo?.valorSacolas) }}</strong><span>nas sacolas ativas</span></div>
        </article>
        <article class="tr-metrica tr-metrica-tempo">
          <span class="tr-metrica-icone"><i class="far fa-clock"></i></span>
          <div>
            <strong>{{ dados.resumo?.ultimoPedidoEm ? formateTempoRelativo(dados.resumo?.ultimoPedidoEm) : '—' }}</strong>
            <span>{{ dados.resumo?.ultimoPedidoEm ? 'saiu o último pedido' : 'sem pedidos na janela' }}</span>
          </div>
        </article>
        <article class="tr-metrica">
          <span class="tr-metrica-icone"><i class="fas fa-receipt"></i></span>
          <div><strong>{{ dados.resumo?.pedidos | number }}</strong><span>{{ dados.resumo?.pedidos === 1 ? 'pedido' : 'pedidos' }} nos últimos {{ janelaMinutos }} min</span></div>
        </article>
      </div>
    </section>

    <aside class="tr-alerta" *ngIf="dados.alertaPagamento?.total" role="alert">
      <span class="tr-alerta-icone"><i class="fas fa-exclamation-triangle"></i></span>
      <div>
        <strong>{{ obtenhaTextoAlertaPagamento() }}</strong>
        <span>Vale conferir se o pagamento online do cardápio está funcionando.</span>
      </div>
    </aside>

    <div class="tr-painel-grid">
      <article class="tr-card tr-jornada">
        <header class="tr-card-header">
          <div><h2>Jornada ao vivo</h2><p>Últimos {{ janelaMinutos }} minutos</p></div>
          <div class="tr-jornada-acoes">
            <button type="button"
                    class="tr-jornada-ver-todos"
                    *ngIf="dados.visitantesAgora"
                    aria-haspopup="dialog"
                    aria-controls="tr-painel-usuarios"
                    [attr.aria-expanded]="listaUsuariosAberta"
                    aria-label="Ver todos os usuários online"
                    (click)="abraListaUsuarios()">
              <i class="fas fa-users"></i>
              <span>Ver todos</span>
              <b>{{ obtenhaTotalFiltroUsuarios('todos') }}</b>
            </button>
            <span class="tr-ajuda" title="Cada visita aparece na etapa mais avançada que alcançou nesta janela."><i class="fas fa-info"></i></span>
          </div>
        </header>

        <div class="tr-etapas" *ngIf="dados.etapas?.length">
          <section class="tr-etapa" *ngFor="let etapa of dados.etapas; let ultima = last; trackBy: trackByEtapa" [attr.data-etapa]="etapa.key">
            <div class="tr-etapa-titulo">
              <span><i [ngClass]="obtenhaIconeEtapa(etapa.key)"></i></span>
              <div><small>{{ etapa.label }}</small><strong>{{ etapa.total | number }}</strong></div>
            </div>
            <div class="tr-etapa-pessoas" [attr.aria-label]="etapa.total + ' acessos em ' + etapa.label">
              <ng-container *ngFor="let visitante of obtenhaVisitantesVisiveis(etapa.key); trackBy: trackByVisitante">
                <button type="button"
                        class="tr-pessoa"
                        kendoTooltip
                        [tooltipTemplate]="pessoaTooltip"
                        tooltipClass="tr-pessoa-kendo-tooltip"
                        position="bottom"
                        showOn="hover"
                        [offset]="10"
                        [showAfter]="80"
                        [tooltipWidth]="260"
                        [class.anonima]="!visitante.identificado"
                        [attr.title]="'Detalhes de ' + obtenhaNomeVisitante(visitante)"
                        [attr.aria-label]="obtenhaDescricaoVisitante(visitante, etapa.label)">
                  <i>
                    <b *ngIf="visitante.identificado">{{ obtenhaIniciaisVisitante(visitante) }}</b>
                    <span class="fas fa-user" *ngIf="!visitante.identificado"></span>
                  </i>
                  <strong>{{ obtenhaNomeVisitante(visitante) }}</strong>
                </button>

                <ng-template #pessoaTooltip>
                  <div class="tr-pessoa-tooltip"
                       [class.anonima]="!visitante.identificado"
                       [attr.data-etapa]="etapa.key">
                    <span class="tr-pessoa-tooltip-cabecalho">
                      <i>
                        <b *ngIf="visitante.identificado">{{ obtenhaIniciaisVisitante(visitante) }}</b>
                        <span class="fas fa-user" *ngIf="!visitante.identificado"></span>
                      </i>
                      <span>
                        <strong>{{ visitante.identificado ? visitante.nomeExibicao : 'Visitante anônimo' }}</strong>
                        <small><i></i>Ativo agora</small>
                      </span>
                    </span>

                    <span class="tr-pessoa-tooltip-dado">
                      <small>Etapa</small>
                      <strong>{{ etapa.label }}</strong>
                    </span>
                    <span class="tr-pessoa-tooltip-dado">
                      <small>Última atividade</small>
                      <strong>{{ visitante.ultimaAtividadeEm ? formateTempoRelativo(visitante.ultimaAtividadeEm) : 'Aguardando primeira ação' }}</strong>
                    </span>
                    <span class="tr-pessoa-tooltip-dado" *ngIf="etapa.key === 'sacola'">
                      <small>Valor da sacola</small>
                      <strong>{{ visitante.valorSacola != null ? formateMoeda(visitante.valorSacola) : 'Não informado' }}</strong>
                    </span>
                    <ng-container *ngIf="visitante.identificado && visitante.telefone">
                      <span class="tr-pessoa-tooltip-dado">
                        <small>Telefone</small>
                        <strong>{{ formateTelefoneVisitante(visitante) }}</strong>
                      </span>
                      <a class="tr-pessoa-tooltip-acao"
                         [href]="obtenhaLinkWhatsapp(visitante)"
                         target="_blank"
                         rel="noopener noreferrer">
                        <i class="fab fa-whatsapp"></i>
                        Enviar mensagem
                      </a>
                    </ng-container>
                    <small class="tr-pessoa-tooltip-nota" *ngIf="!visitante.identificado">Não identificado nesta sessão.</small>
                  </div>
                </ng-template>
              </ng-container>
              <button type="button"
                      class="tr-pessoas-restantes"
                      *ngIf="obtenhaQuantidadeVisitantesOcultos(etapa.key)"
                      aria-haspopup="dialog"
                      aria-controls="tr-painel-usuarios"
                      [attr.aria-expanded]="listaUsuariosAberta && filtroUsuariosEtapa === etapa.key"
                      [attr.aria-label]="'Ver todos os ' + etapa.total + ' usuários em ' + etapa.label"
                      [attr.title]="'Ver todos em ' + etapa.label"
                      (click)="abraListaUsuarios(etapa.key)">
                +{{ obtenhaQuantidadeVisitantesOcultos(etapa.key) }}
              </button>
              <em *ngIf="!etapa.total">—</em>
            </div>
            <i class="fas fa-chevron-right tr-etapa-seta" *ngIf="!ultima"></i>
          </section>
        </div>

        <div class="tr-movimento" [class.vazio]="!houveMovimento()">
          <div class="tr-barras" aria-label="Movimento por minuto">
            <i *ngFor="let minuto of dados.movimento; trackBy: trackByMinuto"
               [style.height.%]="minuto.percentual"
               [attr.title]="minuto.total + ' eventos'"></i>
          </div>
          <div class="tr-eixo"><span>30 min atrás</span><span>20 min</span><span>10 min</span><span>agora</span></div>
          <p *ngIf="!houveMovimento()">Nenhuma atividade registrada nesta janela.</p>
        </div>
      </article>

      <aside class="tr-card tr-atividades">
        <header class="tr-card-header">
          <div><h2>Atividade ao vivo</h2><p>Novas ações aparecem no topo</p></div>
          <i class="tr-pulso"></i>
        </header>

        <div class="tr-feed" *ngIf="dados.atividades?.length; else semAtividades">
          <article *ngFor="let atividade of dados.atividades; trackBy: trackByAtividade" [attr.data-tipo]="atividade.tipo" [class.resolvido]="atividade.resolvido">
            <span class="tr-feed-icone"><i [ngClass]="obtenhaIconeAtividade(atividade.tipo)"></i></span>
            <div>
              <strong>{{ atividade.texto }}</strong>
              <small>
                <span>{{ formateTempoRelativo(atividade.ocorridoEm) }}</span>
                <span class="tr-feed-autor"
                      [class.anonimo]="!atividade.autor?.identificado"
                      [attr.title]="atividade.autor?.identificado ? atividade.autor.nomeExibicao : 'Visitante não identificado'">
                  <i class="far fa-user"></i>{{ obtenhaNomeAutorAtividade(atividade) }}
                </span>
                <span *ngIf="atividade.origem">{{ atividade.origem }}</span>
                <span class="tr-feed-resolvido" *ngIf="atividade.resolvido">resolvida <i class="fas fa-check"></i></span>
              </small>
            </div>
            <i class="tr-device"
               *ngIf="atividade.dispositivo"
               [ngClass]="atividade.dispositivo === 'mobile' ? 'fas fa-mobile-alt' : 'fas fa-desktop'"
               [attr.title]="atividade.dispositivo"></i>
          </article>
        </div>
        <ng-template #semAtividades>
          <div class="tr-vazio"><i class="far fa-clock"></i><strong>Aguardando movimento</strong><span>As próximas ações do cardápio aparecerão aqui.</span></div>
        </ng-template>
      </aside>
    </div>

    <div class="tr-rodape-grid">
      <article class="tr-card tr-produtos">
        <header class="tr-card-header">
          <div><h2>Produtos aquecendo agora</h2><p>Itens que atraíram atenção nesta janela</p></div>
        </header>

        <div class="tr-produtos-cabecalho" *ngIf="dados.produtos?.length">
          <span>Produto</span><span>Viram</span><span>Sacolas</span><span>Valor em sacolas</span>
        </div>
        <div class="tr-produto" *ngFor="let produto of dados.produtos; trackBy: trackByProduto">
          <div class="tr-produto-identidade">
            <span class="tr-produto-imagem">
              <img *ngIf="produto.imagem" [src]="produto.imagem" [alt]="produto.nome" (error)="aoFalharImagem(produto)">
              <b *ngIf="!produto.imagem">{{ obtenhaIniciaisProduto(produto.nome) }}</b>
            </span>
            <strong>{{ produto.nome }}</strong>
          </div>
          <span><small>Viram</small><strong>{{ produto.visualizacoes | number }}</strong></span>
          <span><small>Sacolas</small><strong>{{ produto.sacolas | number }}</strong></span>
          <span class="tr-produto-intencao"><small>Valor</small><strong [class.zerado]="!produto.intencao">{{ formateMoeda(produto.intencao) }}</strong></span>
        </div>
        <div class="tr-vazio tr-vazio-produtos" *ngIf="!dados.produtos?.length">
          <i class="fas fa-hamburger"></i><strong>Ainda sem produto em destaque</strong><span>As visualizações e adições à sacola dos próximos minutos formarão este ranking.</span>
        </div>
      </article>

      <aside class="tr-card tr-oportunidade" [class.tr-oportunidade-ok]="!dados.oportunidade?.sacolasParadas">
        <header class="tr-card-header">
          <div><h2>{{ dados.oportunidade?.sacolasParadas ? 'Oportunidade agora' : 'Tudo fluindo agora' }}</h2><p>Leitura operacional da janela</p></div>
          <span><i class="fas fa-bullseye"></i></span>
        </header>

        <div class="tr-oportunidade-corpo" *ngIf="dados.oportunidade?.sacolasParadas; else semSacolaParada">
          <span class="tr-oportunidade-icone"><i class="fas fa-shopping-bag"></i></span>
          <div>
            <strong>Há {{ dados.oportunidade.sacolasParadas }} {{ dados.oportunidade.sacolasParadas === 1 ? 'sacola parada' : 'sacolas paradas' }} há mais de {{ dados.oportunidade.minutosSemAtividade }} min</strong>
            <p>Elas somam cerca de {{ formateMoeda(dados.oportunidade.valorSacolasParadas) }} que ainda podem virar pedido.</p>
          </div>
        </div>
        <ng-template #semSacolaParada>
          <div class="tr-oportunidade-corpo">
            <span class="tr-oportunidade-icone"><i class="fas fa-check"></i></span>
            <div><strong>Nenhuma sacola parada nesta janela</strong><p>Os clientes com itens escolhidos continuam ativos ou já avançaram.</p></div>
          </div>
        </ng-template>

        <div class="tr-oportunidade-dados">
          <div class="tr-oportunidade-dado">
            <span>Sacolas ativas</span><strong>{{ dados.resumo?.sacolasAtivas | number }}</strong>
          </div>
          <div class="tr-oportunidade-dado">
            <span>Valor nas sacolas ativas</span><strong>{{ formateMoeda(dados.resumo?.valorSacolas) }}</strong>
          </div>
        </div>
      </aside>
    </div>

    <footer class="tr-privacidade">
      <i class="fas fa-user-shield"></i>
      <span>Clientes reconhecidos pela sessão podem ter nome e telefone exibidos. E-mail, documento e IP não são exibidos.</span>
    </footer>
  </ng-container>

  <div class="tr-usuarios-overlay"
       [class.aberto]="listaUsuariosAberta"
       [attr.aria-hidden]="!listaUsuariosAberta">
    <button type="button"
            class="tr-usuarios-fundo"
            [attr.tabindex]="listaUsuariosAberta ? 0 : -1"
            aria-label="Fechar lista de usuários online"
            (click)="fecheListaUsuarios()"></button>

    <aside #painelUsuarios
           id="tr-painel-usuarios"
           class="tr-usuarios-painel"
           role="dialog"
           aria-modal="true"
           aria-labelledby="tr-usuarios-titulo"
           [attr.inert]="listaUsuariosAberta ? null : ''">
      <header class="tr-usuarios-cabecalho" [class.detalhe]="visitanteSelecionado">
        <ng-container *ngIf="visitanteSelecionado; else tituloListaUsuarios">
          <button #botaoVoltarUsuarios
                  type="button"
                  class="tr-usuarios-voltar"
                  aria-label="Voltar para a lista de usuários"
                  (click)="volteParaListaUsuarios()">
            <i class="fas fa-arrow-left"></i>
          </button>
          <div>
            <span class="tr-usuarios-ao-vivo"><i></i>Ao vivo</span>
            <h2 id="tr-usuarios-titulo">{{ obtenhaNomeCompletoVisitante(visitanteSelecionado) }}</h2>
            <p>{{ obtenhaAcoesVisitante().length }} {{ obtenhaAcoesVisitante().length === 1 ? 'ação registrada' : 'ações registradas' }} nos últimos {{ janelaMinutos }} min.</p>
          </div>
        </ng-container>

        <ng-template #tituloListaUsuarios>
          <div>
            <span class="tr-usuarios-ao-vivo"><i></i>Ao vivo</span>
            <h2 id="tr-usuarios-titulo">Usuários online <b>{{ obtenhaTotalFiltroUsuarios('todos') }}</b></h2>
            <p>Veja em que etapa cada pessoa está neste instante.</p>
          </div>
        </ng-template>

        <button #botaoFecharUsuarios
                type="button"
                class="tr-usuarios-fechar"
                aria-label="Fechar lista de usuários online"
                (click)="fecheListaUsuarios()">
          <i class="fas fa-times"></i>
        </button>
      </header>

      <ng-container *ngIf="!visitanteSelecionado; else historicoUsuario">
        <div class="tr-usuarios-controles">
          <label class="tr-usuarios-busca">
            <i class="fas fa-search"></i>
            <input type="search"
                   [value]="buscaUsuarios"
                   placeholder="Buscar usuário"
                   aria-label="Buscar usuário online"
                   (input)="aoBuscarUsuarios($event)">
          </label>

          <div class="tr-usuarios-filtros" aria-label="Filtrar usuários por etapa">
            <button type="button"
                    *ngFor="let filtro of filtrosUsuarios; trackBy: trackByEtapa"
                    [class.ativo]="filtroUsuariosEtapa === filtro.key"
                    [attr.aria-pressed]="filtroUsuariosEtapa === filtro.key"
                    (click)="selecioneFiltroUsuarios(filtro.key)">
              <span>{{ filtro.label }}</span>
              <b>{{ obtenhaTotalFiltroUsuarios(filtro.key) }}</b>
            </button>
          </div>
        </div>

        <div class="tr-usuarios-lista-cabecalho">
          <strong>{{ obtenhaUsuariosFiltrados().length }} {{ obtenhaUsuariosFiltrados().length === 1 ? 'usuário' : 'usuários' }}</strong>
          <span>Mais recentes</span>
        </div>

        <div class="tr-usuarios-lista" role="list" *ngIf="obtenhaUsuariosFiltrados().length; else semUsuariosFiltrados">
          <article role="listitem"
                   *ngFor="let visitante of obtenhaUsuariosFiltrados(); trackBy: trackByVisitante"
                   [attr.data-etapa]="visitante.etapa">
            <button type="button"
                    class="tr-usuario-linha"
                    [attr.aria-label]="'Ver atividade de ' + obtenhaNomeCompletoVisitante(visitante)"
                    (click)="abraHistoricoUsuario(visitante)">
              <span class="tr-usuario-avatar" [class.anonimo]="!visitante.identificado">
                <b *ngIf="visitante.identificado">{{ obtenhaIniciaisVisitante(visitante) }}</b>
                <i class="fas fa-user" *ngIf="!visitante.identificado"></i>
              </span>

              <span class="tr-usuario-identidade">
                <strong>{{ obtenhaNomeCompletoVisitante(visitante) }}</strong>
                <small><i></i>Ativo agora<span>·</span>{{ visitante.ultimaAtividadeEm ? 'última ação ' + formateTempoRelativo(visitante.ultimaAtividadeEm) : 'aguardando primeira ação' }}</small>
              </span>

              <span class="tr-usuario-acoes">
                <span class="tr-usuario-etapa">
                  <i [ngClass]="obtenhaIconeEtapa(visitante.etapa)"></i>
                  {{ obtenhaLabelEtapa(visitante.etapa) }}
                </span>
                <span class="tr-usuario-navegar" aria-hidden="true">
                  <span>Atividade</span>
                  <i class="fas fa-chevron-right"></i>
                </span>
              </span>
            </button>
          </article>
        </div>

        <ng-template #semUsuariosFiltrados>
          <div class="tr-usuarios-vazio" role="status">
            <i class="fas fa-user-slash"></i>
            <strong>Nenhum usuário encontrado</strong>
            <span>Tente outro nome ou selecione uma etapa diferente.</span>
          </div>
        </ng-template>

        <footer class="tr-usuarios-rodape">
          <i class="fas fa-shield-alt"></i>
          <span>A lista acompanha apenas as sessões ativas agora.</span>
        </footer>
      </ng-container>

      <ng-template #historicoUsuario>
        <div class="tr-usuario-resumo" [attr.data-etapa]="visitanteSelecionado.etapa">
          <div class="tr-usuario-resumo-principal">
            <span class="tr-usuario-avatar" [class.anonimo]="!visitanteSelecionado.identificado">
              <b *ngIf="visitanteSelecionado.identificado">{{ obtenhaIniciaisVisitante(visitanteSelecionado) }}</b>
              <i class="fas fa-user" *ngIf="!visitanteSelecionado.identificado"></i>
            </span>
            <div class="tr-usuario-identidade">
              <strong>{{ obtenhaNomeCompletoVisitante(visitanteSelecionado) }}</strong>
              <small><i></i>Ativo agora<span>·</span>{{ visitanteSelecionado.ultimaAtividadeEm ? 'última ação ' + formateTempoRelativo(visitanteSelecionado.ultimaAtividadeEm) : 'aguardando primeira ação' }}</small>
            </div>
            <span class="tr-usuario-etapa" [attr.title]="'Etapa da jornada: ' + obtenhaLabelEtapa(visitanteSelecionado.etapa)">
              <i [ngClass]="obtenhaIconeEtapa(visitanteSelecionado.etapa)"></i>
              {{ obtenhaLabelEtapa(visitanteSelecionado.etapa) }}
            </span>
          </div>

          <div class="tr-usuario-contexto">
            <div class="tr-usuario-contexto-item">
              <span class="tr-usuario-contexto-icone"><i class="fas fa-desktop"></i></span>
              <span>
                <small>Tela atual</small>
                <strong>{{ visitanteSelecionado.telaAtual?.label || 'Não identificada' }}</strong>
                <em *ngIf="visitanteSelecionado.telaAtual?.detalhe">{{ visitanteSelecionado.telaAtual.detalhe }}</em>
              </span>
            </div>

            <div class="tr-usuario-contexto-item tr-usuario-contexto-sacola"
                 [class.com-sacola]="visitanteSelecionado.temSacola">
              <span class="tr-usuario-contexto-icone"><i class="fas fa-shopping-bag"></i></span>
              <span>
                <small>Sacola</small>
                <ng-container *ngIf="visitanteSelecionado.temSacola; else semSacolaSelecionada">
                  <strong>{{ visitanteSelecionado.valorSacola != null ? formateMoeda(visitanteSelecionado.valorSacola) : 'Valor não informado' }}</strong>
                  <em>{{ formateNumero(visitanteSelecionado.itensSacola) }} {{ visitanteSelecionado.itensSacola === 1 ? 'item' : 'itens' }}</em>
                </ng-container>
                <ng-template #semSacolaSelecionada>
                  <strong>Sem itens</strong>
                  <em>Nenhuma sacola ativa</em>
                </ng-template>
              </span>
            </div>
          </div>
        </div>

        <div class="tr-usuarios-lista-cabecalho">
          <strong>Todas as ações</strong>
          <span>Mais recentes</span>
        </div>

        <div class="tr-usuario-historico" role="list" *ngIf="obtenhaAcoesVisitante().length; else semAcoesUsuario">
          <article role="listitem"
                   *ngFor="let acao of obtenhaAcoesVisitante(); trackBy: trackByAtividade"
                   [attr.data-tipo]="acao.tipo"
                   [class.resolvido]="acao.resolvido">
            <span class="tr-historico-icone"><i [ngClass]="obtenhaIconeAtividade(acao.tipo)"></i></span>
            <div>
              <strong>{{ acao.texto }}</strong>
              <small>
                <span>{{ formateHorario(acao.ocorridoEm) }}</span>
                <span>{{ formateTempoRelativo(acao.ocorridoEm) }}</span>
                <span *ngIf="acao.origem">{{ acao.origem }}</span>
                <span *ngIf="acao.resolvido">Resolvida</span>
              </small>
            </div>
            <i class="tr-device"
               *ngIf="acao.dispositivo"
               [ngClass]="acao.dispositivo === 'mobile' ? 'fas fa-mobile-alt' : 'fas fa-desktop'"
               [attr.title]="acao.dispositivo"></i>
          </article>
        </div>

        <ng-template #semAcoesUsuario>
          <div class="tr-usuarios-vazio" role="status">
            <i class="far fa-clock"></i>
            <strong>Nenhuma ação registrada</strong>
            <span>Esta sessão está ativa, mas ainda não enviou uma ação de navegação nesta janela.</span>
          </div>
        </ng-template>

        <footer class="tr-usuarios-rodape">
          <i class="far fa-clock"></i>
          <span>Atividade desta sessão nos últimos {{ janelaMinutos }} minutos.</span>
        </footer>
      </ng-template>
    </aside>
  </div>
</main>
